import { getPagintaionModuleState } from '@/helpers/store-state'

import { State } from './types'

export const getInitialReviewsStoreState = (): State => ({
  listModule: getPagintaionModuleState(),

  reviewsDetails: {},
})
